import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import background from "./images/background.png";

const FeedbackForm = ({ formType }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [device, setDevice] = useState("");
  const [browser, setBrowser] = useState("");
  const [phraseIssue, setPhraseIssue] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      setError("Escribe algo primero 💬");
      return;
    }
    setLoading(true);
    setError("");
    const deviceInfo = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
    };
    try {
      const response = await fetch("/api/submit-feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: formType,
          message,
          ...(formType === "bug" && {
            device,
            browser,
            phraseIssue,
            deviceInfo,
          }),
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Algo salió mal.");
      setSubmitted(true);
      setMessage("");
      setDevice("");
      setBrowser("");
      setPhraseIssue("");
    } catch (err) {
      setError(err.message || "Error inesperado.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => setError(""), 7000);
      return () => clearTimeout(timeout);
    }
  }, [error]);

  const inputStyle = {
    border: "1.5px solid #c4b5fd",
    borderRadius: "12px",
    padding: "10px 12px",
    width: "100%",
    fontSize: "14px",
    color: "#2d1f3d",
    background: "rgba(255,255,255,0.9)",
    outline: "none",
  };

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="max-w-xl mx-auto text-center px-5 py-6"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.12)",
        }}
      >
        <h1 className="text-xl font-bold mb-5" style={{ color: "#b06ab3" }}>
          {formType === "bug" ? "🐞 Algo no funciona" : "💖 Quiero dejar feedback"}
        </h1>

        {submitted ? (
          <p className="font-medium text-sm" style={{ color: "#b06ab3" }}>
            ¡Gracias, bb! Recibí tu mensaje 💌
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 text-left">
            <p className="text-xs mb-2" style={{ color: "#9b7eaa" }}>
              Tipo:{" "}
              <strong style={{ color: "#b06ab3" }}>
                {formType === "bug" ? "Algo no funciona" : "Feedback"}
              </strong>
            </p>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={
                formType === "bug"
                  ? "Cuéntame qué no te funcionó 🐛"
                  : "Cuéntame tu idea o lo que quieras decir 🪄"
              }
              style={{ ...inputStyle, resize: "none" }}
              rows={4}
            />

            {formType === "bug" && (
              <>
                <label className="block">
                  <span
                    className="text-sm font-semibold"
                    style={{ color: "#2d1f3d" }}
                  >
                    ¿En qué dispositivo estás?
                  </span>
                  <select
                    style={{ ...inputStyle, marginTop: "6px" }}
                    value={device}
                    onChange={(e) => setDevice(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="iPhone">iPhone</option>
                    <option value="Android">Android</option>
                    <option value="Desktop">Computadora</option>
                  </select>
                </label>

                <label className="block">
                  <span
                    className="text-sm font-semibold"
                    style={{ color: "#2d1f3d" }}
                  >
                    ¿Qué navegador usas?
                  </span>
                  <select
                    style={{ ...inputStyle, marginTop: "6px" }}
                    value={browser}
                    onChange={(e) => setBrowser(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="Safari">Safari</option>
                    <option value="Chrome">Chrome</option>
                    <option value="Firefox">Firefox</option>
                    <option value="Edge">Edge</option>
                    <option value="Otro">Otro</option>
                  </select>
                </label>

                <label className="block">
                  <span
                    className="text-sm font-semibold"
                    style={{ color: "#2d1f3d" }}
                  >
                    ¿Recuerdas qué frase te falló?
                  </span>
                  <input
                    type="text"
                    value={phraseIssue}
                    onChange={(e) => setPhraseIssue(e.target.value)}
                    placeholder="Ej: 'Se dice PERRÍSIMA no perrucha…'"
                    style={{ ...inputStyle, marginTop: "6px" }}
                  />
                </label>
              </>
            )}

            {error && (
              <p className="text-sm" style={{ color: "#f472b6" }}>
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="bg-custom-blue text-white px-6 py-3 rounded-full font-semibold disabled:opacity-50 active:scale-95 transition-transform w-full"
              style={{ boxShadow: "0 4px 12px rgba(125,211,252,0.4)" }}
            >
              {loading ? "Enviando..." : "Enviar"}
            </button>

            <button
              onClick={() => navigate("/feedback")}
              type="button"
              className="text-xs underline block mx-auto mt-2"
              style={{ color: "#9b7eaa", background: "none", border: "none" }}
            >
              ← Elegir otro tipo de mensaje
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
